import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { MethodType } from '@endeavour/payment-integration';

import { config } from '../../../config/config';
import { useDemographicsFilter } from '../../shared/hooks/demographic';
import { selectLocale } from '../../shared/store/locale.store';
import { usePaymentMethodsQuery } from '../queries/cashier.graphql';

export function usePaymentProviders(filters: { type?: MethodType; slug?: string }) {
    const locale = useSelector(selectLocale);

    const [{ data: paymentList, fetching }] = usePaymentMethodsQuery({
        variables: {
            xTenantID: config.TENANT_ID,
            locale: locale,
            skinId: config.SKIN_ID,
            filter: filters,
        },
    });

    const paymentMethods = useDemographicsFilter(
        useMemo(
            () =>
                paymentList?.getPaymentMethods.filter(
                    (method): method is NonNullable<typeof method> => {
                        return !!method;
                    },
                ) ?? [],
            [paymentList],
        ),
    );

    return useMemo(
        () => ({
            fetching: fetching,
            paymentList: paymentMethods,
        }),
        [fetching, paymentMethods],
    );
}
